bq.accountingMassEdit = function(element, options) {
    this.options   = options;
    this.$element  = $(element);
};

bq.accountingMassEdit.DEFAULTS = {};

bq.accountingMassEdit.prototype = {
    init: function() {
        bq.debug.log("Accounting Mass Edit : init()", this.$element);
        this.$element.on('change', '.accounting-selector-group-checkbox', {context: this}, this._catchDataChangeEvent);
        this.$element.on('change', '#mass_edit_select_all', {context: this}, this._catchSelectAllChangeEvent);
        this.toggleApplyAllButton();
    },

    _catchDataChangeEvent: function(e) {
        var accMassEdit = e.data.context;
        var selectId = $(this).data('for-select-id');
        var $accFormElement = accMassEdit.$element.find('section.accounting-update [data-select-id=' + selectId + ']');
        if (this.checked) {
            $accFormElement.find('input.selectbox-data').prop('disabled', null);
            $accFormElement.show();
        } else {
            $accFormElement.hide();
            $accFormElement.find('input.selectbox-data').prop('disabled', 'disabled');
            $('#mass_edit_select_all').prop('checked', false);
        }
        bq.accountingMassEdit.prototype.toggleApplyAllButton();
    },

    _catchSelectAllChangeEvent: function (e) {
        var accMassEdit = e.data.context;
        var selectAllChecked = this.checked;

        var elements = accMassEdit.$element.find('input[data-for-select-id]');
        var elementsArr = $.makeArray(elements);
        $(elementsArr).each(function(i, el) {
            $(el).prop('checked', selectAllChecked);
            $(el).trigger('change');
        });

        return this;
    },

    toggleApplyAllButton: function () {
        var applyButton = $('#bqat-btnSaveLineChanges');
        var disable = $('input[data-for-select-id]:checked').length < 1;
        applyButton.attr('disabled', disable);
    }
};

$.fn.bqAccountingMassEdit = function (option) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.accountingMassEdit');
        var options = $.extend({}, bq.accountingMassEdit.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

         if (!data) { $this.data('bq.accountingMassEdit', (data = new bq.accountingMassEdit(this, options))); }
        data.init();
    });
};

// ACCOUNTING MASS EDIT DATA-API
// ==============

bq.accountingMassEditInit = function() {
    $('[data-bq="accounting-mass-edit"]').each(function() {
        var $el = $(this);
        if ($el.data('bq.accountingMassEdit')) { return; }
        $el.bqAccountingMassEdit($el.data());
    });
};

bq.init.push(bq.accountingMassEditInit);
